import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { pubApi } from '../../api/publisherClient';
import { PUBLISHER_AGREEMENT } from '../../content/publisherAgreement';
import Logo from '../../components/Logo';

// Kayıttan sonra panele giden her yayıncıya, kabul edene kadar bloke eden
// sözleşme ekranı. `publisher.termsAcceptedAt` null olduğu sürece
// PublisherPanel.jsx panelin GERİSİNİ hiç render etmez, sadece bunu gösterir.
export default function TermsModal({ onAccepted }) {
  const { t } = useTranslation();
  const [busy, setBusy] = useState(false);

  const accept = async () => {
    setBusy(true);
    try {
      const res = await pubApi.acceptTerms();
      onAccepted(res.publisher);
    } finally {
      setBusy(false);
    }
  };

  return (
    <div style={{
      position: 'fixed', inset: 0, zIndex: 1000, background: 'var(--bg-0)',
      display: 'flex', flexDirection: 'column',
    }}>
      <div style={{ padding: '18px 24px', borderBottom: '1px solid var(--border)', flexShrink: 0 }}>
        <Logo />
      </div>

      <div style={{ flex: 1, overflowY: 'auto', padding: '32px 24px' }}>
        <div style={{ maxWidth: 720, margin: '0 auto' }}>
          <h1 style={{ fontSize: '1.5rem', marginBottom: 12 }}>{PUBLISHER_AGREEMENT.title}</h1>
          <p style={{ color: 'var(--text-2)', fontSize: 14, lineHeight: 1.6, marginBottom: 'var(--sp-5)' }}>
            {PUBLISHER_AGREEMENT.intro}
          </p>
          {PUBLISHER_AGREEMENT.sections.map((s, i) => (
            <section className="legal-section" key={i}>
              <h2>{s.h}</h2>
              {s.p.map((para, j) => <p key={j}>{para}</p>)}
            </section>
          ))}
        </div>
      </div>

      <div style={{
        borderTop: '1px solid var(--border)', padding: '16px 24px', flexShrink: 0,
        display: 'flex', justifyContent: 'center', background: 'var(--bg-1)',
      }}>
        <button className="btn" style={{ minWidth: 280 }} onClick={accept} disabled={busy}>
          {busy ? `${t('common.loading')}…` : t('publisher.terms_accept')}
        </button>
      </div>
    </div>
  );
}
